import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Star } from 'src/components/shared/Star';
import { interpolateFreeText } from 'src/i18n';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';
import { getConstructionTheme } from '../promotion/ConstructionTheme';
import { ResortConstructionItem } from '../promotion/ResortConstructionItem';
import { ResortUserInfo } from '../promotion/ResortUserInfo';

interface LockedProfileProps {
  profile: UserResortProfile;
  isMyself: boolean;
}

export const LockedProfile: React.FC<LockedProfileProps> = ({ profile, isMyself }) => {
  const { t } = useTranslation(['resort', 'translation']);
  const history = useHistory();
  const isReported = profile.screening === 'ng';

  const userColor = getResortUserColor(profile.resortPlannerPromotionColor);

  const handleMenuButtonClick = () => {
    history.push(`/deep-link/promotion/${profile.resortPlannerId}/menu`);
  };

  return (
    <div
      className={css`
        padding-top: 20px;
        .constructions {
          display: flex;
          flex-wrap: wrap;
          margin: 24px 0;
          .const-grid-item {
            width: 50%;
            &:nth-child(2n + 1) {
              padding-right: 5px;
            }
            &:nth-child(2n) {
              padding-left: 5px;
            }
          }
        }
        .disabled-follow {
          width: 100%;
          min-height: 44px;
          color: #8f8c85;
          background: #cdc7bb;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-radius: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px 4px;
          margin: 0;
          svg {
            flex: 0 0 auto;
            width: 20px;
            height: 20px;
            margin-right: 4px;
          }
          span {
            white-space: normal;
          }
        }
      `}
    >
      <ResortUserInfo
        name={profile.name}
        image={profile.image}
        isMyself={isMyself}
        isReported={isReported}
        resortPlannerGrade={profile.resortPlannerGrade}
        resortPlannerId={profile.resortPlannerId}
        onMenuClick={isMyself ? undefined : handleMenuButtonClick}
      />

      <ul className="constructions">
        {profile.constructions.slice(0, 2).map(item => {
          const constName = getConstructionTheme(t, item);
          const constNameAriaLabel = interpolateFreeText(
            t,
            'aria_construction_image_01',
            'name',
            constName
          );
          return (
            <li key={item.resortId} className="const-grid-item">
              <div role="img" aria-label={constNameAriaLabel}>
                <ResortConstructionItem construction={item} userColor={userColor} />
              </div>
            </li>
          );
        })}
      </ul>
      {isMyself ? null : (
        <button className="disabled-follow" aria-disabled={true}>
          <Star size={20} innerColor="#cdc7bb" strokeColor="#8f8c85" />
          <span>{t('feature_not_available')}</span>
        </button>
      )}
    </div>
  );
};
